import { types } from 'mobx-state-tree'

import { ScheduleSingleDateDataModel } from './single-date-data'

export const ScheduleDatesModel = types.map(ScheduleSingleDateDataModel)
